<template>
    <transition name="modal">
      <div id="accordionExample">
            <b-card class="modal-requeteIn"> 
                <b-row no-gutters>
                    <b-col lg="10" md="9">
                        <b-card-text class ="pt-2 pb-2">
                        <div class="titreRequete pr-2">{{requete.titre}}</div>
                        </b-card-text>
                    </b-col>

                    <b-col lg="2" md="3" align-self="center" title= "visualiser les informations de la requête">
                        <b-button pill  align-self="center"
                        data-toggle="collapse" :data-target="'#collapse' + requete.idRequete" aria-expanded="true" :aria-controls="'#collapse' + requete.idRequete" class="nav-link1">visualiser <i class="fas fa-eye"></i></b-button>
                    </b-col>
                </b-row>

                <div :id="'collapse' + requete.idRequete"  class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <p><strong>description</strong> : {{requete.description}}</p>
                </div>
            </b-card>
      </div>
    </transition>
</template>

<script>

export default {
    name: 'RequeteItemLancement',

    props: {  
        requete:{
            required:true,
            type:Object
        },
        idjeu:{
          type:Number
        }
    },

}
</script>

<style>
.nav-link1{
  color: white !important;
  font-size: 25px;
}
.nav-link1:hover{
  color: black !important;
}
.titreRequete{
  color: black;
  font-size: 20px;
}
.description{
  color: black;
}

.modal-requeteIn {
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>